module.exports = __webpack_public_path__ + "static/emoji-icon-92aba0ea379e779be0ed36d149b79df1.png";